
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/legal/compliance",
      function () {
        return require("private-next-pages/legal/compliance/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/legal/compliance"])
      });
    }
  